import React from 'react';
import {Box, styled} from '@mui/material';
import {Body, designSystemToken} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

const Container = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

function EmptyRephraseContent() {
  return (
    <Container>
      <Box display="flex" flexDirection="column" gap={2} textAlign="center">
        <Body
          size="lg"
          whiteSpace="pre-wrap"
          color={designSystemToken('semantic.fg.secondary')}
        >
          {translate(
            'Rescript lets you quickly replace parts of speech;\nreview the script and generate a new video.'
          )}
        </Body>
      </Box>
    </Container>
  );
}

export default EmptyRephraseContent;
